import { render, staticRenderFns } from "./UploadMatrix.vue?vue&type=template&id=3f7323b6&scoped=true"
import script from "./UploadMatrix.vue?vue&type=script&lang=js"
export * from "./UploadMatrix.vue?vue&type=script&lang=js"
import style0 from "./UploadMatrix.vue?vue&type=style&index=0&id=3f7323b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7323b6",
  null
  
)

export default component.exports